'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _video = require('video.js');

var _video2 = _interopRequireDefault(_video);

var _ComponentEventProcessorBase = require('./ComponentEventProcessorBase');

var _ComponentEventProcessorBase2 = _interopRequireDefault(_ComponentEventProcessorBase);

var _DebugManager = require('../../utils/DebugManager');

var _DebugManager2 = _interopRequireDefault(_DebugManager);

var _axios = require('axios');

var _axios2 = _interopRequireDefault(_axios);

var _constants = require('../constants');

var _componentData = require('../../models/componentData');

var _constants2 = require('../../EventPump/constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var dmInstance = _DebugManager2.default.dmInstance;

/**
 * Creates an ComponentEventProcessor Plugin to process
 * events returned from componentEvent/archived endpoint and 
 * manually adds cues to the text track 
 *
 * @param {Player} player
 *        A Video.js player instance.
 * 
 * @param {Object} options 
 *        The options to configure the plugin.
 * 
 *        Options object should include:
 * 
 *        @param {Function} dataHandler
 *        Data handler when the plugin fires `componentEvent`.
 * 
 *        @param {Function} trackHandler
 *        Event handler to process a newly added track.
 *
 *        @param {string} vttEndpoint
 *        Endpoint to retrieve component event data
 * 
 */

var ComponentEventProcessor = function (_ComponentEventProces) {
  _inherits(ComponentEventProcessor, _ComponentEventProces);

  function ComponentEventProcessor(player, options) {
    _classCallCheck(this, ComponentEventProcessor);

    return _possibleConstructorReturn(this, (ComponentEventProcessor.__proto__ || Object.getPrototypeOf(ComponentEventProcessor)).call(this, player, options));
  }

  /**
   * Initialize text track and invoke loadTrackData
   *
   * @override
   */


  _createClass(ComponentEventProcessor, [{
    key: 'init',
    value: function init(opts) {
      _get(ComponentEventProcessor.prototype.__proto__ || Object.getPrototypeOf(ComponentEventProcessor.prototype), 'init', this).call(this, opts);

      this.vttEndpoint = opts.vttEndpoint;
      this.textTrack = null;
    }
  }, {
    key: 'addEventListeners',


    /**
     * Subscribe to `componentEvent` and invoke the dataHandler that's
     * passed in via options.  Forward the component event data to the dataHandler.
     */
    value: function addEventListeners() {
      var _this2 = this;

      this.on(_constants.VideoEvents.COMPONENT_EVENT, function (event, data) {
        _this2.dataHandler(event, data);
      });

      this.player.one('loadedmetadata', function (evt) {
        var _this3 = this;

        this.textTrack = this.player.addRemoteTextTrack({ kind: 'metadata', label: 'Timed Metadata', srclang: 'en' }, false);
        this.textTrack.mode = 'hidden';

        this.loadTrackData(this.vttEndpoint).then(function (data) {
          _this3.parseTextTrackData(data.data.data);
        }).catch(function (err) {
          console.log(err);
        });
      }.bind(this));

      // need to reset the starting point on seek
      // and call handleCueChange to force an update
      this.player.on("seeked", function (evt) {
        this.lastProcessedStartTime = 0;
        this.handleCueChange(this.player.textTracks()[0]);
      }.bind(this));
    }

    /**
     * Load track data by invoking passed endpoint
     *
     * @return {Promise} Axios promise
     *
     * @param {string} endpoint Endpoint to invoke
     */

  }, {
    key: 'loadTrackData',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(endpoint) {
        var localAxios;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                localAxios = _axios2.default.create({
                  timeout: 5000,
                  responseType: 'json'
                });

                localAxios.defaults.headers.common['Content-Type'] = 'application/json';

                _context.next = 4;
                return localAxios.get(endpoint, {
                  withCredentials: true
                });

              case 4:
                return _context.abrupt('return', _context.sent);

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function loadTrackData(_x) {
        return _ref.apply(this, arguments);
      }

      return loadTrackData;
    }()

    /**
     * Manually add cues
     *
     * @param {Array} trackData Data to parse
     */

  }, {
    key: 'parseTextTrackData',
    value: function parseTextTrackData(trackData) {
      trackData.forEach(function (cueData) {
        //We are not going to add any events related to the lobby or exit screens
        if ((0, _componentData.hasScreen)(cueData.payload, _constants2.ScreenTypesEnum.LOBBY) || (0, _componentData.hasScreen)(cueData.payload, _constants2.ScreenTypesEnum.EXIT)) {
          return;
        }

        //Calculate the new start point for component events. This is done by subtracting the 
        //startTimeOffset (where to begin playback) from the component event startTime.
        //If that value is negative, these events will be processed prior to playback.
        //If its not negative, set to original component event start time (plus 1 second)
        //since it will fire according to the original timeline of the media.
        //Note: the 1 second pad is to compensate for the difference between
        //inband events during a live event and archive events.
        var cueStartTime = void 0;
        if (parseFloat(cueData.startTime - this.startTimeOffset) < 0) {
          cueStartTime = 0;
        } else {
          cueStartTime = parseFloat(cueData.startTime) + 1;
        }

        this.textTrack.track.addCue(new VTTCue(cueStartTime, cueStartTime, JSON.stringify(cueData.payload)));

        dmInstance.logMessage([_DebugManager2.default.debugLevel.V], '[ComponentEventProcessor] cue event added - cueTime: ', cueStartTime, ' data: ', cueData.payload);
      }.bind(this));
    }

    /**
     * @return {Object} event data payload as a json object
     *
     * @override
     */

  }, {
    key: 'parseCueData',
    value: function parseCueData(cue) {
      try {
        return {
          data: [{
            payload: JSON.parse(cue.text)
          }]
        };
      } catch (e) {
        // WARNING: we always need to catch exceptions here so the app can recover from a bad component event!
        dmInstance.logMessage([_DebugManager2.default.debugLevel.V], '[ComponentEventProcessor] parseCueData error ', e);

        console.warn('Unable to parse in-band event data because of an unknown format. Received data: ' + cue.text);
      }
    }
  }]);

  return ComponentEventProcessor;
}(_ComponentEventProcessorBase2.default);

exports.default = ComponentEventProcessor;


_video2.default.registerPlugin('ComponentEventProcessor', ComponentEventProcessor);